import React from 'react';
import { graphql } from 'gatsby';
import { Query } from '../../graphql-types';
import ProgramOverview from '../documents/program/components/ProgramOverview';
import JAZZLetters from '../components/JAZZLetters';
import { Box, Button, Flex, Heading, Input } from 'theme-ui';
import translate from '../shared/translate';
import Layout from '../components/Layout/Layout';
import { useFormik } from 'formik';

// Query
export const pageQuery = graphql`
  query ProgramQuery($currentFestivalId: String) {
    allSanityEvent(
      filter: { festival: { id: { eq: $currentFestivalId } } }
      sort: { fields: date___local }
    ) {
      nodes {
        ...EventBoxFragment
      }
    }
    allSanityVenue {
      nodes {
        ...sanityVenue
      }
    }
    allSanityEventCategory {
      nodes {
        _rawTitle
        id
      }
    }
    sanityFestival(id: { eq: $currentFestivalId }) {
      _rawTitle
    }
  }
`;

 const validate = (
   values: any
 ) => {
   const errors: Record<string, string> = {};

   if (!values.email) {
     errors.email = 'Required';
   } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
     errors.email = 'Invalid email address';
   }

   return errors;
 };

const Program: React.FC<{
  data: Pick<
    Query,
    | 'allSanityEvent'
    | 'allSanityVenue'
    | 'allSanityEventCategory'
    | 'sanityFestival'
  >;
}> = ({ data }) => {
  // const form = useFormik({
  //   initialValues: {
  //     email: '',
  //   },
  //   validate,
  //   onSubmit: (data: { email: string }) => {

  //     console.log('SUBMITTED', data.email);
  //   },
  // });
  if (data.allSanityEvent.nodes.length === 0) {
    return (
      <Layout>
        <JAZZLetters />
        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Heading
            sx={{
              fontFamily: 'mono',
              fontSize: '36px',
              maxWidth: '540px',
              margin: '0 auto',
            }}
          >
            {translate('pre_announcement')}{' '}
            {translate(data.sanityFestival._rawTitle)}{' '}
            {translate('post_announcement')}
          </Heading>
          <Box sx={{ fontFamily: 'mono', fontSize: '15px', mt: 3 }}>
            {translate('Keep updated with our newsletter.')}
          </Box>
          <Box sx={{ maxWidth: '340px', margin: '0 auto', mt: 3 }}>
            <a sx={{}} href={translate('http://eepurl.com/iu7V6')}>
              {translate('Subscribe to our newsletter')}
            </a>
          </Box>
          {/* <Flex sx={{ maxWidth: '340px', margin: '0 auto', mt: 3 }}>
            <Input
              placeholder={translate('e@mail.com')}
              name="email"
              type="email"
              value={form.values.email}
              onChange={form.handleChange}
            />
            {form.isValid && (
              <Button
                onClick={() => form.submitForm()}
                sx={{ border: 0, cursor: 'pointer' }}
              >
                {translate('Subscribe')}
              </Button>
            )}
          </Flex> */}
        </Box>
      </Layout>
    );
  }

  return (
    <Box>
      <ProgramOverview data={data} />
    </Box>
  );
};

export default Program;
